import { EMBEDS_URL } from './constants';

export const browserSupportsIframeSrcdoc =
  global.window && 'srcdoc' in document.createElement('iframe');

export const shouldLoadIframeSrcDoc = (src: string) => src.indexOf('embeds.nerdwallet') !== -1;

// If we know from the src that the iframe shouldn't use srcdoc, render the iframe on both server and client
// If the iframe may render using srcdoc, hold off on rendering until we've attempted to fetch the srcdoc. This lets us avoid
// a duplicative fetch for src if the srcdoc fetch succeeds
export const shouldRenderIframe = (src: string, srcDocFetchComplete: boolean) =>
  !shouldLoadIframeSrcDoc(src) || srcDocFetchComplete;

export const getSrcValue = (id: string | null | undefined, src: string | null | undefined) => {
  if (src) return src;
  if (!id) return '';
  return `${EMBEDS_URL}/embeds/${id}.html?nwaMode=embed`;
};

export const fetchIframeSrcDoc = async (compiledSrc: string) => {
  const response = await fetch(compiledSrc);
  const iframeSrcDoc = await response.text();
  const parser = new DOMParser();
  const dom = parser.parseFromString(iframeSrcDoc, 'text/html');
  const robots = dom.querySelector('meta[name="robots"]');
  if (robots instanceof HTMLElement) {
    robots.remove();
  }
  return dom.documentElement.outerHTML;
};
